SupportUtilsHelper = require('../../../helpers/utils')
SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportFinePrintServiceActionView extends SupportServiceActionsBaseView
  id: 'fine_print'

  events :
    'click #fine_print': 'showFinePrint'

  initialize: ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      service_action_id : 'fine_print'
      service_action : I18n.t("js.modules.support.viewfp")
    @extendHash(hash)

  showFinePrint: ->
    SupportUtilsHelper.renderFinePrint()

module.exports = SupportFinePrintServiceActionView
